import Home from '../views/Home.vue'
import ContactUs from '../views/ContactUs.vue'
import AboutUs from '../views/AboutUs.vue'

import SearchBookInside from '../views/SearchBookInside.vue'

import Home2 from '../views/Home2.vue'


import ReadBook from '../views/ReadBook.vue'
import MyBooks from '../views/MyBooks.vue'
import UploadBook from '../views/UploadBook.vue'
import BookUpdate from '../views/BookUpdate.vue'

import ReadMicros from '../views/Micros/Read.vue'



// import Login from '../views/Auth/Login.vue'
import Login from '../views/Auth/Login.vue'

import Logout from '../views/Auth/Logout.vue'



const routes = [
{
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
        requiresAuth: "GUEST"
    }
},
{
    path: '/contactus',
    name: 'ContactUs',
    component: ContactUs,
    meta: {
        requiresAuth: "GUEST"
    }
},
{
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs,
    meta: {
        requiresAuth: "GUEST"
    }
},

{
    path: '/SearchBookInside',
    name: 'SearchBookInside',
    component: SearchBookInside,
    meta: {
        requiresAuth: "GUEST"
    }
},
{
    path: '/home2',
    name: 'Home2',
    component: Home2,
    meta: {
        requiresAuth: "GUEST"
    }
},

{
    path: '/read-book/:bookID',
    name: 'ReadBook',
    component: ReadBook,
    meta: {
        requiresAuth: "GUEST"
    }
},
{
    path: '/micro/:id/:key',
    name: 'ReadMicros',
    component: ReadMicros,
    props: true,
    meta: {
        requiresAuth: "GUEST"
    }
},
{
    path: '/mybooks',
    name: 'MyBooks',
    component: MyBooks,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/book/:bookID',
    name: 'DetailsBook',
    component: BookUpdate,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/book/upload',
    name: 'UploadBook',
    component: UploadBook,
    props: true,
    meta: {
        requiresAuth: true
    }
},




{
    path: '/login',
    name: 'Login',
    component: Login,
    props: true,
    meta: {
        requiresAuth: false
    }
},

{
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: {
        requiresAuth: true
    }
},

]

export default routes